var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelectArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 10,
    viewBox: "0 0 16 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.0604 9.06088C9.06013 9.0606 9.05968 9.0606 9.0594 9.06088C8.7782 9.34146 8.39717 9.49906 7.9999 9.49906C7.6024 9.49906 7.22115 9.34128 6.9399 9.06038L1.2819 3.40438C1.00064 3.12298 0.84268 2.74138 0.842773 2.34352C0.842867 1.94567 1.00101 1.56414 1.2824 1.28288C1.56379 1.00162 1.9454 0.843656 2.34325 0.84375C2.74111 0.843844 3.12264 1.00198 3.4039 1.28338L5.17147 3.05095C6.73357 4.61305 9.26623 4.61305 10.8283 3.05095L12.5959 1.28338C12.8787 1.01 13.2575 0.858631 13.6508 0.861862C14.0441 0.865093 14.4204 1.02267 14.6986 1.30065C14.9769 1.57863 15.1348 1.95478 15.1384 2.34807C15.142 2.74137 14.991 3.12035 14.7179 3.40338L9.0614 9.06088C9.06112 9.06115 9.06068 9.06115 9.0604 9.06088Z",
    fill: "#717171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectArrow);
export default __webpack_public_path__ + "static/media/selectArrow.ba322f84fa246a914f743d868cb99d64.svg";
export { ForwardRef as ReactComponent };